import { render, staticRenderFns } from "./PeriodePembayaran.vue?vue&type=template&id=2fc0f23e&scoped=true&"
import script from "./PeriodePembayaran.vue?vue&type=script&lang=js&"
export * from "./PeriodePembayaran.vue?vue&type=script&lang=js&"
import style0 from "./PeriodePembayaran.vue?vue&type=style&index=0&id=2fc0f23e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0f23e",
  null
  
)

export default component.exports